@if (payPalConfig) {
  <ngx-paypal
    [config]="payPalConfig"
    (scriptLoaded)="onPaypalScriptLoaded($event)"
  />
}

